import TreeRegistration from './TreeRegistration'

export default TreeRegistration
